/* Navigation de divulgation, pas un menu ARIA applicatif. Aucune requête réseau. */
(() => {
  const notes = ['Florale', 'Fruitée', 'Végétale', 'Épicée', 'Boisée', 'Gourmande'];
  function readPortrait(draft) {
    try {
      const storage = draft ? window.sessionStorage : window.localStorage;
      const value = JSON.parse(storage.getItem(draft ? 'chanoyu.sensoriel.brouillon' : 'chanoyu.sensoriel'));
      if (!value || value.version !== 1 || !['Relaxation', 'Power', 'Flourish'].includes(value.univers) ||
          !Array.isArray(value.notes) || value.notes.length > 3 || new Set(value.notes).size !== value.notes.length ||
          value.notes.some(note => !notes.includes(note)) || !Number.isInteger(value.intensite) ||
          value.intensite < 0 || value.intensite > 100 || !['', 'Peu importe', 'Avec théine', 'Sans théine'].includes(value.theine)) return null;
      if (draft) {
        if (!Number.isInteger(value.step) || value.step < 0 || value.step > 3 ||
            !Number.isInteger(value.reached) || value.reached < Math.max(1, value.step) || value.reached > 4 ||
            typeof value.portraitReady !== 'boolean' || (value.portraitReady && !value.theine)) return null;
      } else if (!value.theine) return null;
      return value;
    } catch (_) { return null; } // Stockage refusé ou ancienne donnée : proposition neutre.
  }
  function init(header) {
    if (header.dataset.menuPret) return;
    header.dataset.menuPret = 'true';
    const trigger = header.querySelector('.section-entete__declencheur');
    const panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    let opened = false, byHover = false, intentTimer, hideTimer;
    const desktop = () => window.matchMedia('(min-width: 990px)').matches;
    const focusInside = () => panel && panel.contains(document.activeElement);
    function refreshPortrait() {
      const draft = readPortrait(true);
      const saved = draft || readPortrait(false);
      header.querySelectorAll('[data-menu-portrait]').forEach(card => {
        const put = (part, value) => { card.querySelector('[data-menu-portrait-' + part + ']').textContent = value; };
        put('repere', draft ? 'Votre parcours en cours' : saved ? 'Votre portrait de goût' : 'Votre boussole sensorielle');
        put('titre', draft ? 'On continue ?' : saved ? 'Vos goûts, en quelques notes.' : 'Suivez vos sens.');
        put('texte', draft ? 'Vos choix sont conservés. Retrouvez votre parcours là où vous l’avez laissé.' : saved ?
          (saved.notes.length ? saved.notes.join(' · ') + '. ' : 'Au fil de vos envies. ') +
          'Une tasse ' + (saved.intensite < 34 ? 'délicate' : saved.intensite < 67 ? 'équilibrée' : 'corsée') + '.' :
          'Quelques choix pour dessiner votre portrait de goût.');
        put('action', draft ? 'Reprendre mon parcours' : saved ? 'Retrouver mon portrait' : 'Explorer mes goûts');
      });
    }
    function close(restore = true) {
      clearTimeout(intentTimer); clearTimeout(hideTimer);
      if (!panel || !opened) return;
      opened = false; byHover = false;
      trigger.setAttribute('aria-expanded', 'false');
      if (restore && focusInside()) (desktop() ? trigger : header.querySelector('.section-entete__marque')).focus();
      panel.inert = true;
      panel.classList.remove('est-ouvert');
      hideTimer = setTimeout(() => { if (!opened) panel.hidden = true; }, 240);
    }
    function open(hover = false) {
      clearTimeout(intentTimer); clearTimeout(hideTimer);
      if (!panel || !desktop()) return;
      refreshPortrait();
      if (opened) return;
      opened = true; byHover = hover;
      header.dispatchEvent(new CustomEvent('chanoyu:menu-ouvert'));
      panel.style.setProperty('--menu-depart', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      panel.hidden = false; panel.inert = false;
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => { if (opened) panel.classList.add('est-ouvert'); });
    }
    header.addEventListener('chanoyu:menu-mobile-ouvert', refreshPortrait);
    header.addEventListener('chanoyu:recherche-ouverte', () => close());
    header.addEventListener('click', event => {
      const link = event.target.closest('[data-menu-parcours]');
      if (!link || event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = document.querySelector('[data-sensoriel][data-sensoriel-pret] [data-s-etape]:not([hidden]) .sensoriel__titre');
      if (!target) return; // Sans parcours initialisé sur cette page : vraie destination Liquid.
      event.preventDefault();
      close(false);
      header.dispatchEvent(new CustomEvent('chanoyu:menu-fermer'));
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    if (!trigger || !panel) return;
    trigger.addEventListener('click', () => {
      if (byHover) { byHover = false; clearTimeout(intentTimer); }
      else if (opened) close(); else open();
    });
    trigger.addEventListener('mouseenter', () => {
      if (!desktop() || !window.matchMedia('(hover: hover)').matches || opened) return;
      clearTimeout(intentTimer); intentTimer = setTimeout(() => open(true), 300);
    });
    trigger.addEventListener('mouseleave', () => { if (!opened) clearTimeout(intentTimer); });
    panel.addEventListener('mouseenter', () => clearTimeout(intentTimer));
    header.addEventListener('mouseleave', () => {
      clearTimeout(intentTimer);
      if (opened && !focusInside()) intentTimer = setTimeout(() => close(), 300);
    });
    panel.addEventListener('focusin', () => clearTimeout(intentTimer));
    header.addEventListener('focusout', () => {
      setTimeout(() => { if (opened && !focusInside() && document.activeElement !== trigger) close(); }, 0);
    });
    trigger.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown' && !(event.key === 'Tab' && !event.shiftKey && opened)) return;
      event.preventDefault(); open(); byHover = false;
      const first = panel.querySelector('.menu-comptoir__famille') || panel.querySelector('a[href], button');
      if (first) first.focus();
    });
    panel.querySelector('[data-ferme-comptoir]').addEventListener('click', () => { close(); trigger.focus(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && opened) { event.preventDefault(); close(); trigger.focus(); }
    });
    document.addEventListener('click', event => {
      if (!panel.contains(event.target) && !trigger.contains(event.target)) close();
    });
    window.addEventListener('resize', () => {
      if (!desktop()) close();
      else if (opened) panel.style.setProperty('--menu-depart', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    });
  }
  function boot(scope) { scope.querySelectorAll('[data-entete]').forEach(init); }
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
